"use client";

import Image from "next/image";
import styles from "./styles.module.scss";
import cn from "clsx";
import { useContext, useEffect } from "react";
import { pushToDataLayer } from "@/helpers/gtag";
import DownloadCTASticky from "./DownloadCTASticky/DownloadCTASticky";
import EnrollNowButton from "./EnrollNowButton/EnrollNowButton";
import { getGlobalStateValue } from "@/context/utils";
import { usePathname } from "next/navigation";
import { ModalContext } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import RightArrowNew from "@/SvgIcons/RightArrowNew";
import RightArrow from "@/SvgIcons/RightArrow";

export default function LandingPageHeader({ data }) {
const { header, templateType } = data;
const pathName = usePathname();
const { modalDispatch } = useContext(ModalContext);

  if (!header?.enabled) return null;

  const isAfricaPage = pathName === "/africa";

  useEffect(()=>{
    pushToDataLayer({
      event : "page_type",
      page_type : getGlobalStateValue('pageType')
    })
  },[]);

  const scrollToLeadForm = (scrollTo)=> {
    console.log(scrollTo, "scrollTo");
    document.getElementById(scrollTo)?.scrollIntoView({
      block: "start",
    });
  }

  const GAEventsHandler = () => {
    pushToDataLayer({
      'event':'logo_click',
      'section_name':'top navigation bar',
      'page_type': getGlobalStateValue('pageType') 
      });
  }

  const onClickCTAHandler = () => {

    pushToDataLayer({
      event: "enquire_now_enroll_now_cta_click",
      cta_text: data?.CTA?.text || "NA",
      section_name: "Top Navigation Bar",
      page_type: "Campaign Page",
    });
    scrollToLeadForm("#leadform");

  }

  const studentLoginhandler = () => {

    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
         modalType: ModalTypes.LoginModal,
      },
    })

    setTimeout(() => {
      pushToDataLayer({
        "event": "student_login_initiate",
        "cta_text": "STUDENT LOGIN",
        "page_type": getGlobalStateValue("pageType"),
        "page_url": location.href
      });
    }, 2500);

  }

  const CustomButton = () => {
    return header.CTA.url.includes("#") ? (
      <>
        {isAfricaPage ? (
          <button onClick={studentLoginhandler} className={styles.studentLogin}>
            Existing Student Login <RightArrow  className={styles.svgHover} stroke="#FFF"/>
          </button>
        ) : (
          <button onClick={onClickCTAHandler} className={styles.btn}>
            {header?.CTA?.text} <RightArrowNew stroke="#1a325d"/>
          </button>
        )}
      </>
    ) : (
      <a
        href={header?.CTA?.url || ""}
        className={styles.btn}
        target={header?.CTA?.target?.[0] || "_self"}
      >
        {header?.CTA?.text} &#8594;
      </a>
    );
  };    


  return (
    <>
      <header
        className={cn("container", styles.header)}
      >
        <div className={styles.headerContainer}>
          {header?.Logo?.enabled ? (
            <img
              onClick={GAEventsHandler}
              src={header?.Logo?.source?.data?.[0]?.attributes?.url}
              alt={header?.Logo?.alt || ""}
              className={styles.logo}
            />
          ) : null}

          {header?.CTA?.enabled ? <CustomButton /> : null}
        </div>
      </header>

      {templateType === "template1" ? (
        <EnrollNowButton associatedPrograms={data.headerMenu.associatedPrograms}/>
      ) : (
        <DownloadCTASticky associatedPrograms={data.headerMenu.associatedPrograms} />
      )}
    </>
  );
}
